import { render, staticRenderFns } from "./all_wait_receive.vue?vue&type=template&id=08bba8a6&scoped=true"
import script from "./all_wait_receive.vue?vue&type=script&lang=js"
export * from "./all_wait_receive.vue?vue&type=script&lang=js"
import style0 from "./all_wait_receive.vue?vue&type=style&index=0&id=08bba8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bba8a6",
  null
  
)

export default component.exports